import { Box, Typography } from "@mui/material";
import { Navbar } from "../components/Navbar/Navbar";
import { Footer } from "../components/Footer/Footer";
import { aboutMeText1, aboutMeText2 } from "../utils/aboutMeText";

const AboutMe = () => {

    return (
        <>
            <Navbar />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: { xs: 4, md: 8 },
                    px: { md: 6 },
                }}
            >
                <Box
                    sx={{
                        width: { md: '900px' },
                        height: 'auto',
                        mb: 4
                    }}
                >
                    <img
                        src="/images/about-me.webp"
                        alt="About Me"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </Box>

                <Box
                    sx={{
                        textAlign: 'center',
                        width: { xs: '90%', sm: '70%', md: '60%' },
                        px: { xs: 2, md: 4 },
                    }}
                >
                    <Typography variant="h3" sx={{ mb: 2 }}>
                        About me
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ mb: 1.5, lineHeight: 1.8, fontSize: { xs: '1rem', md: '1.1rem' } }}
                    >
                        {aboutMeText1}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ mb: 1.5, lineHeight: 1.8, fontSize: { xs: '1rem', md: '1.1rem' } }}
                    >
                        {aboutMeText2}
                    </Typography>
                </Box>
            </Box>
            <Footer />
        </>
    )
}

export default AboutMe;